import React, { useState } from 'react';
import { format } from 'date-fns';
import SafeIcon from '../../common/SafeIcon';
import EditEntryModal from './EditEntryModal';
import EntryHistoryModal from './EntryHistoryModal';

export default function LedgerItem({ entry, onUpdate }) {
  const [showEdit, setShowEdit] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  
  // Ensure amount is treated as a number
  const amount = Number(entry.amount || 0);
  const isPositive = amount >= 0;

  return (
    <div className="p-4 hover:bg-gray-50 transition-colors flex justify-between items-center group">
      <div className="flex-1 cursor-pointer flex items-center space-x-4" onClick={() => setShowHistory(true)}>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${isPositive ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
          <SafeIcon icon={isPositive ? 'ArrowUpRight' : 'ArrowDownRight'} className="w-5 h-5" />
        </div>
        <div>
          <div className="flex items-center space-x-2">
            <span className={`font-bold text-lg ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
              {isPositive ? '+' : ''}{amount.toFixed(2)}
            </span>
            {entry.edited_at && (
              <span className="text-[10px] font-bold px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full uppercase tracking-tighter">Edited</span>
            )}
          </div>
          <p className="text-sm text-gray-700 mt-0.5 font-medium">{entry.note || 'Transaction'}</p>
          <p className="text-[10px] text-gray-400 mt-1 flex items-center font-bold uppercase tracking-wider">
            <SafeIcon icon="Calendar" className="w-3 h-3 mr-1" /> 
            {format(new Date(entry.created_at), 'MMM d, yyyy • h:mm a')}
          </p>
        </div>
      </div>
      <div className="opacity-0 group-hover:opacity-100 transition-opacity flex space-x-2">
        <button onClick={(e) => { e.stopPropagation(); setShowEdit(true); }} className="p-2 text-gray-400 hover:text-indigo-600 transition-colors bg-white rounded-xl shadow-sm border border-gray-100">
          <SafeIcon icon="Edit2" className="w-4 h-4" />
        </button>
      </div>

      {showEdit && <EditEntryModal entry={entry} onClose={() => setShowEdit(false)} onSuccess={onUpdate} />}
      {showHistory && <EntryHistoryModal entry={entry} onClose={() => setShowHistory(false)} />}
    </div>
  );
}